<template>
  <div class="personal-info-container">
    <!-- 标题 -->

    <!-- 主要内容区域 -->
    <div class="main-content">
        <div class="title">身材类型</div>

      <div class="form-content">
        <!-- 身体类型选择列表 -->
        <div class="bodies">
            <div
                    v-for="(b, i) in bodies"
                    :key="i"
                    class="body-card"
                    :class="{ active: bodyType === b.name }"
                    @click="bodyType = b.name"
                    @mouseenter="hoveredBody = b.name"
                    @mouseleave="hoveredBody = null"
            >
                <img :src="getBodyImage(b)" :alt="b.name" class="figure"/>
                <div v-if="bodyType !== b.name" class="body-name">{{ getBodyTypeName(b.name) }}</div>
                <div v-if="bodyType === b.name" class="body-nameCheck">{{ getBodyTypeName(b.name) }}</div>
            </div>
        </div>
        
        <!-- 身高选择 -->
        <div class="form-group">
          <label class="form-label">身高 (cm)</label>
          <div class="horizontal-picker-container">
            <div class="horizontal-picker-overlay">
              <div class="horizontal-picker-center"></div>
            </div>
            <div class="horizontal-picker-scroll" ref="heightPicker" @scroll="handleHeightScroll">
              <div class="horizontal-picker-padding"></div>
              <div
                v-for="(h, index) in heightRanges"
                :key="index"
                :class="['horizontal-picker-item', { 'selected': selectedHeightIndex === index }]"
                @click="selectHeight(index)"
              >
                {{ h }}
              </div>
              <div class="horizontal-picker-padding"></div>
            </div>
          </div>
        </div>
        
        <!-- 体重选择 -->
        <div class="form-group">
          <label class="form-label">体重 (kg)</label>
          <div class="horizontal-picker-container">
            <div class="horizontal-picker-overlay">
              <div class="horizontal-picker-center"></div>
            </div>
            <div class="horizontal-picker-scroll" ref="weightPicker" @scroll="handleWeightScroll">
              <div class="horizontal-picker-padding"></div>
              <div
                v-for="(w, index) in weightRanges"
                :key="index"
                :class="['horizontal-picker-item', { 'selected': selectedWeightIndex === index }]"
                @click="selectWeight(index)"
              >
                {{ w }}
              </div>
              <div class="horizontal-picker-padding"></div>
            </div>
          </div>
        </div>
        
        <!-- 确认按钮 -->
        <div class="confirm-section">
          <button
            class="confirm-button"
            :class="{ disabled: !isFormValid || isLoading, loading: isLoading }"
            :disabled="!isFormValid || isLoading"
            @click="handleSubmit"
          >
            <!-- 加载状态 -->
            <div v-if="isLoading" class="loading-content">
              <div class="loading-spinner"></div>
              <div class="loading-text">处理中...</div>
            </div>
            <!-- 正常状态 -->
            <div v-else class="button-content">
              <div class="confirm-icon"><img :src="okImg"/></div>
              <div class="confirm-text">确定</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import hourglassImg from "@/assets/images/character/hourglass.svg";
import hourglassImgCheck from "@/assets/images/character/hourglassImgCheck.svg";
import triangleImg from "@/assets/images/character/triangle.svg";
import triangleImgCheck from "@/assets/images/character/triangleCheck.svg";
import invertedTriangle from "@/assets/images/character/invertedTriangle.svg";
import invertedTriangleCheck from "@/assets/images/character/invertedTriangleCheck.svg";
import shapedBody from "@/assets/images/character/shapedbody.svg";
import shapedBodyCheck from "@/assets/images/character/shapedbodyCheck.svg";
import rectangle from "@/assets/images/character/rectangle.svg";
import rectangleCheck from "@/assets/images/character/rectangleCheck.svg";
import okImg from "@/assets/images/svg/ok.svg";
import { StartExploreApi } from '@/api/startExplore'
import {expiredStorage} from "@/utils/expiredStorage";
const bodies = [
    {name: 'hourglass', image: hourglassImg, imageCheck: hourglassImgCheck},
    {name: 'Triangle', image: triangleImg, imageCheck: triangleImgCheck},
    {name: 'Inverted triangle', image: invertedTriangle, imageCheck: invertedTriangleCheck},
    {name: 'O-shaped body', image: shapedBody, imageCheck: shapedBodyCheck},
    {name: 'rectangle', image: rectangle, imageCheck: rectangleCheck}
]
// 定义 emits
const emit = defineEmits(['next', 'back', 'validation-change'])

// 定义 props 来接收回填数据
const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({})
  },
  // 接收来自FormContainer的所有表单数据
  allFormData: {
    type: Object,
    default: () => ({})
  }
})
const bodyType = ref(props.initialData.bodyType || 'O-shaped body')
const hoveredBody = ref(null)

// 身高范围数据
const heightRanges = ref([
    '< 150','150-155', '155-160', '160-165', '165-170', '170-175', '175-180', '180-185', '185-190','> 190'
])

// 体重范围数据
const weightRanges = ref([
    '< 40','40-45', '45-50', '50-55', '55-60', '60-65', '65-70', '70-75', '75-80', '80-85', '85-90','> 90'
])

// 响应式数据
const selectedHeight = ref(props.initialData.height || '165-170')
const selectedWeight = ref(props.initialData.weight || '55-60')
const isLoading = ref(false)

// 选择器索引
const selectedHeightIndex = ref(heightRanges.value.findIndex(h => h === selectedHeight.value))
const selectedWeightIndex = ref(weightRanges.value.findIndex(w => w === selectedWeight.value))

// 如果找不到，默认选中中间
if (selectedHeightIndex.value === -1) {
  selectedHeightIndex.value = Math.floor(heightRanges.value.length / 2)
  selectedHeight.value = heightRanges.value[selectedHeightIndex.value]
}
if (selectedWeightIndex.value === -1) {
  selectedWeightIndex.value = Math.floor(weightRanges.value.length / 2)
  selectedWeight.value = weightRanges.value[selectedWeightIndex.value]
}

// Refs for picker elements
const heightPicker = ref(null)
const weightPicker = ref(null)

// 添加缺失的变量定义
const email = ref('') // 邮箱变量
const height = ref(selectedHeight.value) // 身高变量
const weight = ref(selectedWeight.value) // 体重变量
const uploadedImage = ref(null) // 上传的图片变量
const bodyImageFor = (b) => {
    // If the body is the currently selected one, use the checked image if available
    const selected = bodyType.value === b.name
    if (selected && b.imageCheck) return b.imageCheck
    return b.image
}
// 计算范围的中间值
const calculateMiddleValue = (range) => {
    if (!range || typeof range !== 'string') return ''
    
    // 处理特殊情况：< 40, < 150, > 90, > 190 等，直接返回整数
    if (range && (range.includes('<') || range.includes('>'))) {
        // 提取数字部分
        const num = parseFloat(range.replace(/[<>]/g, '').trim())
        if (!isNaN(num)) {
            return Math.round(num).toString()
        }
        return range
    }
    
    // 检查是否是范围格式 (例如: "165-170")
    if (range && range.includes('-')) {
        const parts = range.split('-')
        if (parts.length === 2) {
            const min = parseFloat(parts[0])
            const max = parseFloat(parts[1])
            if (!isNaN(min) && !isNaN(max)) {
                return ((min + max) / 2).toString()
            }
        }
    }
    
    // 如果不是范围格式，直接返回原值
    return range
}

const ok= async ()=>{
    // 从allFormData中获取Step3的照片数据
    const step3Data = props.allFormData.step3 || {}
    const uploadResult = props.allFormData.uploadResult || null
    const payload = {
        userId: 'onboard-Max-' + Date.now()
    }
    console.log('=== PersonalInfoStep2Content ok函数 ===')
    
    // 计算身高和体重的中间值
    const heightMiddle = calculateMiddleValue(height.value)
    const weightMiddle = calculateMiddleValue(weight.value)
    
    const req={
        face_image:step3Data.avatarFile,
        // body_description:`${height.value}cm, ${weight.value}kg`,
        height: heightMiddle,
        weight: weightMiddle,
        shape:getBodyTypeName(bodyType.value)
    }
    console.log('最终payload:', req)
    console.log('身高范围:', height.value, '-> 折中值:', heightMiddle)
    console.log('体重范围:', weight.value, '-> 折中值:', weightMiddle)
    isLoading.value = true
    expiredStorage.setItem('user',payload)
    try {
        const token =  await StartExploreApi.startExplore(req)
        console.log('StartExplore API调用成功:', token)
        payload.face_image_url=token.image_url
        expiredStorage.setItem('user',payload)
        StartExploreApi.notifyDataSaved()
    } catch (error) {
        console.error('StartExplore API调用失败:', error)
        StartExploreApi.notifyDataSaveFailed(error)
    } finally {
        isLoading.value = false
    }
}
// 获取身体类型图片，支持悬停效果
const getBodyImage = (b) => {
    // 如果当前身体类型被选中，使用选中状态的图片
    const selected = bodyType.value === b.name
    if (selected && b.imageCheck) return b.imageCheck
    
    // 如果当前身体类型被悬停，使用悬停状态的图片
    const hovered = hoveredBody.value === b.name
    if (hovered && b.imageCheck) return b.imageCheck
    
    // 否则使用默认图片
    return b.image
}

// 身体类型名称映射
const getBodyTypeName = (bodyTypeName) => {
  const nameMap = {
    'hourglass': '沙漏型',
    'Triangle': '梨形',
    'Inverted triangle': 'T字型',
    'O-shaped body': 'O字型',
    'rectangle': 'H型'
  }
  return nameMap[bodyTypeName] || bodyTypeName
}

// 计算属性
const isFormValid = computed(() => {
  return bodyType.value !== null && bodyType.value !== '' && 
         selectedHeight.value !== null && selectedHeight.value !== '' &&
         selectedWeight.value !== null && selectedWeight.value !== ''
})

// 监听验证状态变化并通知父组件
watch(isFormValid, (newValue) => {
  nextTick(() => {
    emit('validation-change', newValue)
  })
})

// 监听props变化，更新本地数据
watch(() => props.initialData, (newInitialData) => {
  if (newInitialData && newInitialData.bodyType !== undefined) {
    bodyType.value = newInitialData.bodyType
  }
}, { deep: true })

// 组件挂载后初始化选择器位置
onMounted(() => {
  nextTick(() => {
    // 初始化身高选择器位置
    if (heightPicker.value) {
      scrollToCenter(heightPicker.value, selectedHeightIndex.value)
    }
    // 初始化体重选择器位置
    if (weightPicker.value) {
      scrollToCenter(weightPicker.value, selectedWeightIndex.value)
    }
    
    emit('validation-change', isFormValid.value)
  })
})

// 验证邮箱格式
const validateEmailFormat = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

// 验证邮箱输入
const validateEmail = () => {
  // 可以在这里添加实时验证逻辑
}

// 验证姓名输入
const validateName = () => {
  // 可以在这里添加实时验证逻辑
}

// 验证身高输入
const validateHeight = () => {
  if (parseFloat(height.value) < 0) {
    height.value = ''
  }
}

// 验证体重输入
const validateWeight = () => {
  if (parseFloat(weight.value) < 0) {
    weight.value = ''
  }
}

// 身高选择
const selectHeight = (index) => {
  selectedHeightIndex.value = index
  selectedHeight.value = heightRanges.value[index]
  height.value = selectedHeight.value
  scrollToCenter(heightPicker.value, index)
}

const handleHeightScroll = () => {
  if (!heightPicker.value) return
  const scrollLeft = heightPicker.value.scrollLeft
  const itemWidth = 120 // 每个选项的宽度，需要和CSS中的.horizontal-picker-item宽度一致
  const centerIndex = Math.round(scrollLeft / itemWidth)
  if (centerIndex !== selectedHeightIndex.value && centerIndex >= 0 && centerIndex < heightRanges.value.length) {
    selectedHeightIndex.value = centerIndex
    selectedHeight.value = heightRanges.value[centerIndex]
    height.value = selectedHeight.value
  }
}

// 体重选择
const selectWeight = (index) => {
  selectedWeightIndex.value = index
  selectedWeight.value = weightRanges.value[index]
  weight.value = selectedWeight.value
  scrollToCenter(weightPicker.value, index)
}

const handleWeightScroll = () => {
  if (!weightPicker.value) return
  const scrollLeft = weightPicker.value.scrollLeft
  const itemWidth = 120 // 每个选项的宽度，需要和CSS中的.horizontal-picker-item宽度一致
  const centerIndex = Math.round(scrollLeft / itemWidth)
  if (centerIndex !== selectedWeightIndex.value && centerIndex >= 0 && centerIndex < weightRanges.value.length) {
    selectedWeightIndex.value = centerIndex
    selectedWeight.value = weightRanges.value[centerIndex]
    weight.value = selectedWeight.value
  }
}

// 滚动到居中位置（横向）
const scrollToCenter = (element, index) => {
  if (!element) return
  const itemWidth = 120 // 需要和CSS中的.horizontal-picker-item宽度一致
  element.scrollTo({
    left: index * itemWidth,
    behavior: 'smooth'
  })
}



// 返回上一页（这里可以发射事件给父组件处理）
const goBack = () => {
  // 发射返回事件给父组件
  emit('back')
}

// 进入下一页
const goNext = async () => {
  if (!isFormValid.value) return

  // 先执行ok函数，等待其完成
   ok()
  
  // ok函数执行完成后，继续执行后续逻辑
  const stepData = {
    bodyType: bodyType.value,
    height: selectedHeight.value,
    weight: selectedWeight.value
  }

  emit('next', stepData)
}

// 为了兼容，保持handleSubmit方法名
const handleSubmit = goNext

// 暴露方法给父组件调用
defineExpose({
  handleSubmit
})
</script>

<style scoped>
/* 主容器 - 全屏竖屏布局 */
.personal-info-container {
  width: 100vw;
  height: 100vh;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(135deg, 
    rgba(30, 30, 30, 0.95) 0%, 
    rgba(45, 45, 45, 0.9) 50%, 
    rgba(30, 30, 30, 0.95) 100%);
  backdrop-filter: blur(20px);
  border: none;
  border-radius: 0;
  padding: 40px 30px;
  box-shadow: none;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  overflow-x: hidden;
  /*transform: scale(2);*/
}

.personal-info-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.1) 0%, 
    rgba(255, 255, 255, 0.05) 50%, 
    rgba(255, 255, 255, 0.02) 100%);
  pointer-events: none;
  border-radius: 0;
}

/* 标题样式 */
.title {
  color: rgba(255, 255, 255, 0.95);
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 45px;
  letter-spacing: 1px;
  line-height: 1.3;
  text-align: center;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* 主要内容区域 */
.main-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  flex: 1;
  position: relative;
  z-index: 1;
  max-width: 600px;
  margin: 0 auto;
}

/* 表单内容区域 */
.form-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 35px;
  align-items: stretch;
}
@media (orientation: portrait) {
    .title{
        margin-bottom: 2%;
        color: rgba(255, 255, 255, 0.95);
        font-size: 26px;
        font-weight: 600;
        letter-spacing: 1px;
        line-height: 1.3;
        text-align: center;
        position: relative;
        z-index: 1;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }
    .main-content {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: center;
        width: 100%;
        position: relative;
        flex: 1;
        z-index: 1;
        max-width: 600px;
        margin: 0 auto;
        margin-bottom: 24%;
    }
    .personal-info-container{
        transform: scale(2);
    }
}



.sub-title {
    color: rgba(255, 255, 255, 0.9);
    font-weight: 600;
    font-size: 18px;
    text-transform: lowercase;
    letter-spacing: 0.5px;
    margin-bottom: 20px;
}

.bodies {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    flex-wrap: wrap;
    padding: 0 5px;
}

.body-card {
    flex: 1;
    min-width: 0;
    height: 230px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor: pointer;
    /*background: rgba(255, 255, 255, 0.08);*/
    /*border: 2px solid rgba(255, 255, 255, 0.15);*/
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    padding: 15px 8px;
    position: relative;
    overflow: hidden;
}

.body-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.1) 0%, 
        rgba(255, 255, 255, 0.05) 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 14px;
}

.body-card:hover::before {
    opacity: 1;
}

.body-card.active {
    background: rgba(255,255,255,0.2);
    box-shadow: inset 0px 0px 10px 2px rgba(0,0,0,0.8);
    transform: translateY(-2px);
}

.body-card:hover:not(.active) {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.25);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.figure {
    width: 100px;
    height: 100px;
    object-fit: contain;
    border-radius: 6px;
    opacity: 0.9;
    transition: all 0.3s ease;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.body-card.active .figure {
    /* 让图标填充绿色 */
    fill: rgba(166, 245, 93, 1);
    stroke: rgba(166, 245, 93, 1);
}

.body-name {
    color: rgba(255, 255, 255, 0.85);
    font-size: 23px;
    font-weight: 800;
    text-align: center;
    transition: all 0.3s ease;
}

.body-nameCheck {
    color: #4CAF50;
    font-size: 23px;
    font-weight: 800;
    text-align: center;
    transition: all 0.3s ease;
}

.body-card.active .body-name {
    color: rgba(255, 255, 255, 1);
    font-weight: 600;
}

/* 表单组样式 */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
}

/* 标签样式 */
.form-label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 19px;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* 横向选择器容器样式 */
.horizontal-picker-container {
  position: relative;
  width: 100%;
  height: 60px;
  margin: 0 auto;
  overflow: hidden;
}

.horizontal-picker-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 2;
}

.horizontal-picker-overlay::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 80px;
}

.horizontal-picker-overlay::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 80px;
}

.horizontal-picker-center {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 120px;
  transform: translateX(-50%);
  background: rgba(166, 245, 93, 0.1);
  pointer-events: none;
  border-radius: 8px;
    background: rgba(255,255,255,0.2);
    box-shadow: inset 0px 0px 6px 2px rgba(0,0,0,0.8);
    border-radius: 6px 6px 6px 6px;
    border: 0px solid #000000;
}

.horizontal-picker-scroll {
  width: 100%;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  -ms-overflow-style: none;
  scrollbar-width: none;
  display: flex;
  align-items: center;
}

.horizontal-picker-scroll::-webkit-scrollbar {
  display: none;
}

.horizontal-picker-padding {
  width: calc(50% - 60px);
  flex-shrink: 0;
}

.horizontal-picker-item {
  width: 120px;
  height: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  scroll-snap-align: center;
  user-select: none;
}

.horizontal-picker-item.selected {
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-weight: 600;
}

.horizontal-picker-item:hover {
  color: rgba(255, 255, 255, 0.8);
}

/* 确认按钮区域 */
.confirm-section {
  margin-top: 40px;
  display: flex;
  justify-content: stretch;
  width: 100%;
}

.confirm-button {
    margin:0 auto;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 16px 32px;
    background: rgba(255,255,255,0.4);
  color: rgba(255, 255, 255, 0.98);
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(15px);
  box-shadow:
    0 8px 25px rgba(0, 0, 0, 0.3),
    0 4px 12px rgba(0, 0, 0, 0.2);
  width: 28%;
  justify-content: center;
  position: relative;
  overflow: hidden;
  letter-spacing: 0.5px;
    height: 66px;

}

.confirm-button::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 1), 
    rgba(178, 178, 178, 0.8), 
    rgba(178, 178, 178, 0.4), 
    rgba(178, 178, 178, 0.4), 
    rgba(178, 178, 178, 0.8), 
    rgba(255, 255, 255, 0.9));
  border-radius: 25px;
  padding: 2px;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: xor;
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  z-index: -1;
}

.confirm-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.2) 0%, 
    rgba(255, 255, 255, 0.1) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 16px;
}

.confirm-button:hover::before {
  opacity: 1;
}

.confirm-button:hover:not(.disabled)::after {
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 1), 
    rgba(200, 200, 200, 0.9), 
    rgba(200, 200, 200, 0.6), 
    rgba(200, 200, 200, 0.6), 
    rgba(200, 200, 200, 0.9), 
    rgba(255, 255, 255, 1));
}

.confirm-button.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: rgba(100, 100, 100, 0.3);
  color: rgba(255, 255, 255, 0.4);
  transform: none;
}

.confirm-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.confirm-text {
  font-size: 19px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* 按钮内容容器 */
.button-content {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* 加载状态样式 */
.confirm-button.loading {
  background: rgba(76, 175, 80, 0.8) !important;
  cursor: not-allowed;
}

.loading-content {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid rgba(255, 255, 255, 1);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  color: rgba(255, 255, 255, 0.95);
  font-size: 16px;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

</style>

